import { useSelector } from 'react-redux';

import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import { Grid, Stack } from '@mui/material';

import useSWR from 'swr';
import { fetcher } from '../../common/utils/fetcher';
import Wysiwyg from '../shared/Wysiwyg';

const LabelAndDisplay = ({ label = '', direction='row', value, children, variant='default', sx={}, dynamicLabel=null }) => {
    const retailer = useSelector(state => state.retailer);
    const isRow = direction === 'row';

    const { data: dynamicLabelData } = useSWR(dynamicLabel ? {
        url: dynamicLabel.detailsUrl,
        ...dynamicLabel.detailsPayload,
    } : null, fetcher);

    let dynamicLabelValue = null;
    let labelValue = label;

    if (dynamicLabelData) {
        dynamicLabelValue = dynamicLabel.detailsResponseHandler(dynamicLabelData);
        labelValue = dynamicLabelValue?.title;
    }

    let content = null;

    switch (variant) {
        case 'table':
            content = (
                <Stack
                    direction={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                >
                    <Box
                        sx={{
                            borderLeft: `4px solid ${retailer?.brand_color || 'rgb(51, 51, 51)'}`,
                            pl: 1
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '0.75rem',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                color: 'rgba(0, 0, 0, 0.64)'
                            }}
                        >
                            {labelValue}
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            overflowX: 'hidden',
                            textWrap: 'none',
                        }}
                    >
                        <Typography
                            component="div"
                            sx={{
                                fontSize: '1rem',
                                textWrap: 'none'
                            }}
                        >
                            <Wysiwyg>
                                {value}
                            </Wysiwyg>
                        </Typography>
                    </Box>
                </Stack>
            );
            break;
        case 'statistic':
            content = (
                <Stack direction='column'
                    sx={{
                        p: 2,
                    }}
                >
                    <Box
                        sx={{
                            borderLeft: `4px solid ${retailer?.brand_color || 'rgb(51, 51, 51)'}`,
                            pl: 1
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                            }}
                        >
                            {labelValue}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography
                            sx={{
                                fontSize: '5rem',
                                fontWeight: 'bold',
                            }}
                        >
                            {value}
                        </Typography>
                    </Box>
                    {
                        children &&
                        <Box>
                            {children}
                        </Box>
                    }
                </Stack>
            )
            break;
        default:
            content = (
                <Grid container
                    spacing={1}
                >
                    <Grid item
                        xs={12}
                        md={isRow ? 4 : 12}
                        lg={isRow ? 3 : 12}
                    >
                        <Box
                            sx={{
                                borderLeft: `4px solid ${retailer?.brand_color || 'rgb(51, 51, 51)'}`,
                                pl: 1
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '0.75rem',
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    color: 'rgba(0, 0, 0, 0.64)'
                                }}
                            >
                                {label}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item
                        xs={12}
                        md={isRow ? 8 : 12}
                        lg={isRow ? 9 : 12}
                        sx={{
                            textWrap: 'none'
                        }}
                    >
                        {
                            value &&
                            <Box
                                sx={{
                                    overflowX: 'hidden',
                                    textWrap: 'none'
                                }}
                            >
                                <Typography
                                    component="div"
                                    sx={{
                                        fontSize: '1rem',
                                        textWrap: 'none'
                                    }}
                                >
                                    <Wysiwyg>
                                        {value}
                                    </Wysiwyg>
                                </Typography>
                            </Box>
                        }
                        {
                            children &&
                            <Stack
                                alignItems={isRow ? 'flex-start' : 'center'}
                                sx={{
                                    width: '100%',
                                }}
                            >
                                {children}
                            </Stack>
                        }
                    </Grid>
                </Grid>
            )
    }

    return (
        <Box
            sx={{
                fontWeight: 500,
                fontSize: '16px',
                background: '#fff',
                color: '#000',
                marginTop: '32px',
                marginBottom: '16px',
                boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.13)',
                my: 2,
                ...sx
            }}
        >
            {content}
        </Box>
    )
}

export default LabelAndDisplay